import React from 'react';
import { Badge } from './ui/Badge';
interface ScoreDisplayProps {
  score: number;
  level: 'On Track' | 'Approaching' | 'Needs Support';
  isBeginningReader?: boolean;
  showLabel?: boolean;
  compact?: boolean;
}
export function ScoreDisplay({
  score,
  level,
  isBeginningReader = false,
  showLabel = true,
  compact = false
}: ScoreDisplayProps) {
  // Visual configuration based on level
  const config = {
    'On Track': {
      color: 'bg-teal-500',
      textColor: 'text-teal-700',
      bgColor: 'bg-teal-50',
      width: '85%',
      label: 'On Track'
    },
    Approaching: {
      color: 'bg-amber-400',
      textColor: 'text-amber-700',
      bgColor: 'bg-amber-50',
      width: '55%',
      label: 'Approaching'
    },
    'Needs Support': {
      color: 'bg-coral-500',
      textColor: 'text-coral-700',
      bgColor: 'bg-coral-50',
      width: '25%',
      label: 'Needs Support'
    }
  };
  const current = config[level];
  if (compact) {
    return <div className="flex items-center gap-2" data-id="element-38">
        <div className={`h-2.5 w-2.5 rounded-full ${current.color}`} data-id="element-39"></div>
        <span className="font-medium text-stone-900" data-id="element-40">
          {isBeginningReader ? 'Early Reader' : `${score}L`}
        </span>
        <span className={`text-xs px-2 py-0.5 rounded-full ${current.bgColor} ${current.textColor} font-medium`} data-id="element-41">
          {current.label}
        </span>
      </div>;
  }
  return <div className="w-full" data-id="element-42">
      <div className="flex justify-between items-end mb-2" data-id="element-43">
        <div data-id="element-44">
          {showLabel && <div className="text-sm text-stone-500 font-medium mb-1" data-id="element-45">
              Reading Level
            </div>}
          <div className="flex items-baseline gap-2" data-id="element-46">
            <span className="text-3xl font-bold text-stone-900 tracking-tight" data-id="element-47">
              {isBeginningReader ? 'Early Reader' : score}
              {!isBeginningReader && <span className="text-lg text-stone-400 font-normal ml-0.5" data-id="element-48">
                  L
                </span>}
            </span>
          </div>
        </div>
        <Badge variant={level === 'On Track' ? 'success' : level === 'Approaching' ? 'warning' : 'danger'} data-id="element-49">
          {current.label}
        </Badge>
      </div>

      {/* Progress Bar Visualization */}
      <div className="relative h-3 w-full bg-stone-100 rounded-full overflow-hidden" data-id="element-50">
        {/* Background segments representing the bands */}
        <div className="absolute inset-0 flex opacity-30" data-id="element-51">
          <div className="w-1/3 h-full bg-coral-200 border-r border-white" data-id="element-52"></div>
          <div className="w-1/3 h-full bg-amber-200 border-r border-white" data-id="element-53"></div>
          <div className="w-1/3 h-full bg-teal-200" data-id="element-54"></div>
        </div>

        {/* Actual score indicator */}
        <div className={`absolute top-0 left-0 h-full ${current.color} rounded-full transition-all duration-1000 ease-out`} style={{
        width: current.width
      }} data-id="element-55"></div>
      </div>

      <div className="flex justify-between mt-1 text-xs text-stone-400 font-medium" data-id="element-56">
        <span data-id="element-57">Needs Support</span>
        <span data-id="element-58">Approaching</span>
        <span data-id="element-59">On Track</span>
      </div>
    </div>;
}